import React, { useState, useEffect } from 'react';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';
import { storage } from '../../utils/firebase'; // Importing the storage from firebase config
import './ThingsIntroduction.css'; // Import the CSS file for styling

const ThingsIntroduction = () => {
  const [imageUrls, setImageUrls] = useState([]);
  const [currentImage, setCurrentImage] = useState(0); // Track the current image index

  // Fetching images from Firebase storage
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const images = [
          'home/kainansabalsa.jpg',
          'home/ecopark.jpg',
          'home/brickwoodph.jpg',
          'home/smcitymolino.jpg',
          'home/nomo.jpg',
          'home/somo.jpg',
        ];

        const imagePromises = images.map(async (path) => {
          const imageRef = ref(storage, path);
          const url = await getDownloadURL(imageRef);
          return url;
        });

        const urls = await Promise.all(imagePromises);
        setImageUrls(urls);
      } catch (error) {
        console.error('Error fetching images from Firebase:', error);
      }
    };

    fetchImages();

    // Change image every 2 seconds
    const intervalId = setInterval(() => {
      setCurrentImage((prevIndex) => (prevIndex + 1) % imageUrls.length); // Loop through images
    }, 4000);

    return () => clearInterval(intervalId); // Clean up the interval when the component is unmounted
  }, [imageUrls.length]);

  const handleArrowClick = (direction) => {
    setCurrentImage((prevIndex) =>
      direction === 'left'
        ? (prevIndex - 1 + imageUrls.length) % imageUrls.length
        : (prevIndex + 1) % imageUrls.length
    );
  };

  const handleDotClick = (index) => {
    setCurrentImage(index);
  };

  return (
    <div className="places-introduction">
      <div className="slider">
        {/* Left Arrow */}
        <button
          className="arrow left-arrow"
          onClick={() => handleArrowClick('left')}
        >
          &#8592;
        </button>

        {/* The images will slide in this container */}
        <div
          className="slide-container"
          style={{
            transform: `translateX(-${currentImage * 100}%)`,
            transition: 'transform 1s ease-in-out', // Smooth transition
          }}
        >
          {imageUrls.map((url, index) => (
            <div
              key={index}
              className="slide"
              style={{
                backgroundImage: `url(${url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
                width: '100%',
              }}
            />
          ))}
        </div>

        {/* Right Arrow */}
        <button
          className="arrow right-arrow"
          onClick={() => handleArrowClick('right')}
        >
          &#8594;
        </button>

        {/* Dots for navigation */}
        <div className="dots-container">
          {imageUrls.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentImage ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            ></button>
          ))}
        </div>
      </div>

      {/* Overlay with gradient on top of the background image */}
      <div className="image-overlay"></div>

      {/* Content */}
      <div className="text-content">
        <h1>Activities to do in Bacoor</h1>
        <p>Activity ideas to add to your next trip</p>
      </div>
    </div>
  );
};

export default ThingsIntroduction;
